module.exports = __webpack_public_path__ + "static/media/nosotros.0f9d1bdb.jpg";